import workspaceService from 'services/WorkspaceService';
import getCoursewareAncestry from 'services/ActivityService/queries/getCoursewareAncestry';
import { createApolloClient } from 'ConnectionManager/apolloClient';

const apolloClient = createApolloClient();

export default class CoursewareTargetService {
  async createTarget(id) {
    const { id: workspaceId } = workspaceService.getSelectedWorkspace();
    const result = await getCoursewareAncestry(apolloClient, {
      elementId: id,
      workspaceId,
    });
    return result;
  }

  static build() {
    return new CoursewareTargetService();
  }
}
